import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@lenovo/material/dialog';
import { ExportLogErrorStatus } from 'src/app/enums/export-log.enum';
import { BaseHardwareScanModalComponent } from 'src/app/modules/hardware-scan/components/modal/base-hardware-scan-modal';
import { DeviceService } from 'src/app/services/device/device.service';

@Component({
	selector: 'vtr-modal-export-log',
	templateUrl: './modal-export-log.component.html',
	styleUrls: ['./modal-export-log.component.scss'],
})
export class ModalExportLogComponent extends BaseHardwareScanModalComponent {
	@Input() logPath = '';
	@Input() errorStatus: ExportLogErrorStatus;

	public enumExportLogErrorStatus = ExportLogErrorStatus;

	constructor(
		public dialogRef: MatDialogRef<ModalExportLogComponent>,
		private deviceService: DeviceService
	) {
		super();
	}

	onClosing() {
		this.dialogRef.close();
	}

	openWindowsSettings() {
		this.deviceService.launchUri('ms-settings:privacy-broadfilesystemaccess');
	}
}
